import React from 'react';
import { motion } from 'framer-motion';

const Marquee = () => {
  const text = 'EXCELENCIA · PROFESIONALISMO · PASIÓN · CALIDAD · ';
  const repeatedText = text.repeat(20);

  return (
    <div className="bg-[#60A5FA] py-4 overflow-hidden">
      <motion.div
        className="whitespace-nowrap"
        animate={{
          x: [0, -1920],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear',
        }}
      >
        <span className="text-white text-2xl md:text-4xl font-bold">
          {repeatedText}
        </span>
      </motion.div>
    </div>
  );
};

export default Marquee;
